export const KEYS = {
    getMe: 'get-me',
    regions: 'regions-list',
    districts: 'districts-list',
    branches: 'branches-list',
    typeofobject: 'typeofobject-list',
    object: 'object-list',
    typeofpolice: 'typeofpolice-list',
    typeofrisk: 'typeofrisk-list',
    risk: 'risk-list',
    role: 'role-list',
    insuranceForm: 'insuranceForm',
    classes: 'classes-list',
    subclasses: 'subclasses-list',
    typeofsector: 'typeofsector-list',
    policyformats: 'policyformats-list',
    typeofinsurer: 'typeofinsurer-list',
    groupsofproducts: 'groupsofproducts-list',
    subgroupsofproducts: 'subgroupsofproducts-list',
    applicationformdocs: 'applicationformdocs-list',
    contractform: 'contractform-list',
    additionaldocuments: 'additionaldocuments-list',
    typeofclaimsettlement: 'typeofclaimsettlement-list',
    typeofrefund: 'typeofrefund-list',
    typeoffranchise: 'typeoffranchise-list',
    products: 'products-list',
    product: 'products',
    typeofpersons: 'typeofpersons-list',
    statusofproduct: 'statusofproduct-list',
    agents: 'agents-list',
    typeofpayment: 'typeofpayment',
    baseoffranchise: 'baseoffranchise',
    subgroupsofproductsFilter: 'subgroupsofproducts-filter',
    riskFilter: 'risk-filter',
    tengebankContracts: 'tengebank-contarcts',
    translations: 'translations',
    typeofagent: 'typeofagent',
    accountroles: 'accountroles',
    bank: 'bank',
    accountstatus: 'accountstatus',
    citizenship: 'citizenship',
    genders: 'genders',
    position: 'position',
    typeofdocuments: 'typeofdocuments',
    levelofbranch: 'levelofbranch',
    breanchstatus: 'breanchstatus',
    typeofdocumentsformanager: 'typeofdocumentsformanager',
    reasons: 'reasons',
    agreements: 'agreements',
    typeofendorsements: 'typeofendorsements',
    statusofendorsements: 'statusofendorsements',
    fieldofendorsements: 'fieldofendorsements',
    productsfilter: 'productsfilter',
    agentsfilter: 'agreements/agentsfilter',
    paymentcurrency: 'paymentcurrency',
    objectFilterByType: 'object-filter-by-type',
    districtsByRegion: 'districtsByRegion',
    policy: 'policy',
    statusofpolicy: 'statusofpolicy',
    statusofpayment: 'statusofpayment',
    endorsements: 'endorsements',
    policyFilter: 'policyFilter',
    endorsementFilter: 'endorsementFilter',
    transactions: 'transactions',
    transactionlog: 'transactionlog',
    transactionExcel: 'transactionExcel',
    statusbcopolicy: 'statusbcopolicy',
    actstatus: 'actstatus',
    acts: 'acts',
    bco: 'bco',
    typeofbco: 'typeofbco',
    languagepolicy: 'languagepolicy',
    warehouse: "warehouse",
    user: "user",
    clients: "clients",
    policyblank: "policyblank",
    statusoftypebco: "statusoftypebco",
    checkBlank: "checkBlank",
    clientsFind: "clientsFind",
    employee: "employee",
    objectFields: "objectFields",
    sendToFond: "sendToFond",
    orgInfo: "orgInfo",
    personalInfo: "personalInfo",
    transactionPolicies: "transactionPolicies",
    transactionAgreements: "transactionAgreements",
    transactionAttach: "transactionAttach",
    transactionDistribute: "transactionDistribute",
    personalInfoProvider: "personalInfoProvider",
    ownershipForms: "ownershipForms",
    organizationInfoProvider: "organizationInfoProvider",
    residentTypes: "residentTypes",
    countries: "countries",
    okeds: "okeds",
    vehicleType: "vehicleType",
    propertyType: "propertyType",
    propertyRightType: "propertyRightType",
    agriculturalType: "agriculturalType",
    measurementType: "measurementType",
    bcoStatus: "bcoStatus",
    bcoLanguage: "bcoLanguage",
    act: "act",
    actStatus: "actStatus",
    userStatus: "userStatus",
    findOrCreateClient: "findOrCreateClient",
    residentType: "residentType",
    documentType: "documentType",
    account: "account",
    distributeType: "distributeType",
    transactionLogs: "transactionLogs",
    osgorCreate: 'osgorCreate',
    osgorList: 'osgorList',
    osgorView: 'osgorView',
    osgorDelete: 'osgorDelete',
    osgorEdit: 'osgorEdit',
    osgorConfirmPayment: 'osgorConfirmPayment',
    osgorCheckPayment: 'osgorCheckPayment',
    osgorEpolis: 'osgorEpolis',
    osgopCreate: 'osgopCreate',
    osgopView: 'osgopView',
    osgopDelete: 'osgopDelete',
    osgopList: 'osgopList',
    osgopConfirmPayment: 'osgopConfirmPayment',
    osgopCheckPayment: 'osgopCheckPayment',
    osgopEpolis: 'osgopEpolis',
    personalInfoNonCitizenProvider: 'personalInfoNonCitizenProvider',
    vehicleInfoProvider: 'vehicleInfoProvider',
    vehicleInfoForeignProvider: 'vehicleInfoForeignProvider',
    driverLicenceProvider: 'driverLicenceProvider',
    passengerLicenceProvider: 'passengerLicenceProvider',
    isPensionerProvider: 'isPensionerProvider',
    isDisabledProvider: 'isDisabledProvider',
    areaTypes: 'areaTypes',
    insuranceTerms: 'insuranceTerms',
    agencies: 'agencies',
    vehicleTypes: 'vehicleTypes',
    activityAndRisk: 'activityAndRisk',
    osgorCalculate: 'osgorCalculate',
    getRatio: 'getRatio',
    osgopCalculate: 'osgopCalculate',

    osagoCreate: 'osagoCreate',
    osagoView: 'osagoView',
    osagoList: 'osagoList',
    osagoDelete: 'osagoDelete',
    osagoEdit: 'osagoEdit',
    osagoSend: 'osagoSend',
    osagoConfirmPayment: 'osagoConfirmPayment',
    osagoCheckPayment: 'osagoCheckPayment',
    ePolis: 'ePolis',
    osagoPersonalInfoProvider: 'osagoPersonalInfoProvider',
    osagoOrganizationInfoProvider: 'osagoOrganizationInfoProvider',
    osagoDriverLicenceProvider: 'osagoDriverLicenceProvider',
    osagoPassengerLicenceProvider: 'osagoPassengerLicenceProvider',
    osagoIsPensionerProvider: 'osagoIsPensionerProvider',
    osagoIsDisabledProvider: 'osagoIsDisabledProvider',
    osagoRegions: 'osagoRegions',
    osagoDistricts: 'osagoDistricts',
    osagoGenders: 'osagoGenders',
    osagoResidentTypes: 'osagoResidentTypes',
    osagoInsuranceTerms: 'osagoInsuranceTerms',
    calculator: 'calculator',
    termCategories: 'termCategories',
    accidentTypes: 'accidentTypes',
    discounts: 'discounts',
    vehicleInfo: 'vehicleInfo',
    osagoVehicleTypes: 'osagoVehicleTypes',
    driverTypes: 'driverTypes',
    osagoCountries: 'osagoCountries',
    driverInfo: 'driverInfo',
    relatives: 'relatives',

    smrCreate: 'smrCreate',
    smrList: 'smrList',
    smrView: 'smrView',
    smrDelete: 'smrDelete',
    smrEdit: 'smrEdit',
    smrSendFond: 'smrSendFond',
    smrConfirmPayment: 'smrConfirmPaymentt',
    smrCheckPayment: 'smrCheckPayment',
    smrEpolis: 'smrEpolis',
    smrCalculate: 'smrCalculate',
    smrContractForm: 'smrContractForm',
    getPolisFile: 'getPolisFile',
    calculate: 'calculate',
    smrAttach: 'smrAttach',
    smrDistribute: 'smrDistribute',
    getCadastrInfo: 'getCadastrInfo',
    agentCommission: 'agentCommission',
    file: 'file',
    agentAgreement: 'agentAgreement',
    policyByAgent: 'policyByAgent',
    agentAct: 'agentAct',
    agentActList: 'agentActList',
    showFile: 'showFile',
    otherObjectType: 'otherObjectType',
    agreementWeeklyReport: 'agreementWeeklyReport',
    specificList: 'specificList',
    unattachPolicy: 'unattachPolicy',
    currencyList: 'currencyList',
    eimzoChallenge:'eimzoChallenge',
    eimzoPkcs7:'eimzoPkcs7',
    agreementGtkDetails:'agreementGtkDetails',
    agreementGtkSend:'agreementGtkSend',
    policyUseType:'policyUseType',
    policyIntentType:'policyIntentType',
    agreementPortfelReport:'agreementPortfelReport',
    smrPortfelReport:'smrPortfelReport',
    osgorPortfelReport:'osgorPortfelReport',
    osgopPortfelReport:'osgopPortfelReport',
    osgagoPortfelReport:'osgagoPortfelReport',
    nbuIntegrations:'nbuIntegrations',
    nbuPortfelReport:'nbuPortfelReport',
    claimList:'claimList',
    claimCreate:'claimCreate',
    claimDraft:'claimDraft',
    claimShow:'claimShow',
    claimHistory:'claimHistory',
}
